import React, { useReducer, useRef } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'antd';

import OnTraccrButton from '../../../common/buttons/OnTraccrButton';
import useToggle from '../../../common/hooks/useToggle';
import ScheduleReminderDrawer from '../../../schedule/ScheduleReminderDrawer';
import { REMINDER_OPTIONS } from '../../../schedule/reminder/reminder.constants';
import { formSectionsPropType } from '../../forms.propTypes';

const validDataTypes = new Set(['Shifts']);

const defaultReminderConfig = {
  reminders: [REMINDER_OPTIONS.DEFAULT_REMINDER],
  externalReminders: [{ value: REMINDER_OPTIONS.DEFAULT_REMINDER, recipients: [] }],
};

export default function TableScheduleReminder({
  configProps,
  updateConfig,
  sections,
  dataType,
}) {
  const formRef = useRef();
  const [, forceUpdate] = useReducer((x) => x + 1, 0);
  const { toggle, isToggled } = useToggle(false);
  const { reminderConfig } = configProps;

  const onOpen = () => {
    if (formRef.current) {
      formRef.current.setFieldsValue(reminderConfig || defaultReminderConfig);
    }
    toggle();
  };

  const onClose = () => {
    if (formRef.current) {
      const values = formRef.current.getFieldsValue();
      updateConfig({ reminderConfig: values });
    }
    toggle();
  };

  if (!validDataTypes.has(dataType)) return null;

  return (
    <Form
      ref={formRef}
      initialValues={reminderConfig || defaultReminderConfig}
      onValuesChange={() => forceUpdate()}
    >
      <OnTraccrButton
        title="Configure Schedule Reminders"
        onClick={onOpen}
        style={{ marginTop: 10 }}
      />
      <ScheduleReminderDrawer
        form={formRef}
        visible={isToggled}
        onClose={onClose}
        isFormConfig
        sections={sections}
      />
    </Form>
  );
}

TableScheduleReminder.propTypes = {
  configProps: PropTypes.shape({
    reminderConfig: PropTypes.shape({}),
  }).isRequired,
  updateConfig: PropTypes.func.isRequired,
  sections: formSectionsPropType.isRequired,
  dataType: PropTypes.string.isRequired,
};
